import { useHistory, useLocation, useRouteMatch } from 'react-router-dom';

export const useQueryParams = () => {
  const history = useHistory();
  const { path, params } = useRouteMatch();
  const location = useLocation();
  const search = location.search;

  const updateParams = (updatedParams: any) => {
    Object.assign(params, updatedParams);
    history.push({
      pathname: path,
      search: `?${new URLSearchParams(params)}`,
    });
  };
  const pushUrl = (url: string, search: any) => {
    history.push({
      pathname: url,
      search: search,
    });
  };

  const useQueryString = () => {
    return new URLSearchParams(search);
  };

  return { updateParams, pushUrl, useQueryString, search };
};
